export const FILE_FIELDS = [
    "id",
    "name",
    "description",
    "key",
    "src",
    "type",
    "size",
    "tags",
    "createdOn",
    "savedOn",
    "modifiedOn",
    "createdBy.id",
    "createdBy.displayName",
    "createdBy.type",
    "savedBy.id",
    "savedBy.displayName",
    "savedBy.type",
    "modifiedBy.id",
    "modifiedBy.displayName",
    "modifiedBy.type",
    "location.folderId",
    "metadata.image.width",
    "metadata.image.height",
    "metadata.image.format",
    "metadata.image.orientation",
    "metadata.image.crop",
    "metadata.image.focalPoint",
    "metadata.image.alt",
    "metadata.image.caption",
    "metadata.exif",
    "metadata.iptc"
];
